const NEXT_TO_REDIRECT = {
  buy_challenge: "/purchase",
  demo: "/challenge?next=demo",
};

export const getRedirectFromNext = (nextParam) => {
  if (!nextParam) {
    return null;
  }
  return NEXT_TO_REDIRECT[nextParam] ?? null;
};

export const getNextFromRedirect = (redirectPath) => {
  if (!redirectPath) {
    return null;
  }
  const entry = Object.entries(NEXT_TO_REDIRECT).find(
    ([, path]) => path === redirectPath
  );
  return entry ? entry[0] : null;
};
